/* eslint-disable no-undef */
import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'

/**
 * Function creates Redux store from the given reducers
 * and possible initial state.
 *
 * @param {object} reducer
 * @param {object} initialState
 * @return {object}
 */
export const initStore = ( reducer, initialState ) => {
  const middleware = [ thunkMiddleware ]
  const options = {
    name: 'Sponda - Search Application'
  }
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__( options )
    : compose
  const store = createStore( reducer, initialState, composeEnhancers(
    applyMiddleware( ...middleware ),

  ))
  return store
}
